<template>
  <button 
    @click="$emit('toggle')"
    class="inline-flex items-center px-3 py-1.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors shadow-sm text-sm font-medium mr-3 relative"
    :class="{
      'ring-2 ring-red-500': hasActiveAssignments,
      'animate-pulse': hasCrisis
    }"
  >
    <span class="flex items-center">
      <i class="fas mr-2" :class="hasCrisis ? 'fa-exclamation-triangle' : 'fa-bolt'" :style="hasCrisis ? 'color: #f97316;' : 'color: #ef4444;'"></i>
      Canlı Atama
      <!-- Bildirim sayısı -->
      <span 
        v-if="count > 0" 
        class="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center"
      >
        {{ count }}
      </span>
      
      <!-- Kriz sayısı -->
      <span 
        v-if="crisisCount > 0" 
        class="absolute -top-2 -left-2 bg-orange-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center"
        title="Kriz durumundaki sipariş sayısı"
      >
        {{ crisisCount }}
      </span>
    </span>
  </button>
</template>

<script>
export default {
  name: "LiveAssignmentButton",
  props: {
    count: {
      type: Number,
      default: 0
    },
    hasActiveAssignments: {
      type: Boolean,
      default: false
    },
    crisisCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasCrisis() {
      return this.crisisCount > 0;
    }
  }
};
</script>

<style scoped>
@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.4);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(239, 68, 68, 0);
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>